import request from '@/utils/request'

// 重发通知
export const orderNotify = (data: any) => request({
    url: '/manage/order-notify',
    method: 'post',
    data
})

// 订单编辑附件
export const editOrderAttach = (data: any) => request({
    url: '/manage/order/' + data.ordernumber + '/edit',
    method: 'patch',
    data
})
// 批量发送订单
export const batchOrderNotify = (data: any) => request({
    url: '/manage/batch-order-notify',
    method: 'post',
    data
})